'use client';

import { ANALYTICS_CONSENT_KEY } from '@/lib/constants';
import {
  ConsentStorageAdapter,
  createCookieConsentStorageAdapter,
  resolveConsentCookieDomain,
} from '@web-store-platforms/components/cookie-consent';

const resolveDomain = (): string | undefined => {
  const configured = process.env.NEXT_PUBLIC_CONSENT_COOKIE_DOMAIN;
  if (configured) return configured;
  if (typeof window === 'undefined') return undefined;
  return resolveConsentCookieDomain(window.location.hostname);
};

export const cookieConsentStorageAdapter: ConsentStorageAdapter = createCookieConsentStorageAdapter({
  cookieName: ANALYTICS_CONSENT_KEY,
  domain: resolveDomain(),
  legacyLocalStorageKey: ANALYTICS_CONSENT_KEY,
});
